module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/J8VqIB/tc-custom/9781426842696.jpg?1721404315721",
      "alt": "This image is the cover for the book Billionaire's Bride of Innocence, Three Rich Husbands"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Billionaire's Bride of Innocence, Three Rich Husbands\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("James Logan knew it was time to take a wife and produce an heir. Megan was perfect for his plans: shy, unworldly and quickly seduced by the Sydney advertising tycoon's devilish charm. She was pregnant on their wedding day."), _c('br'), _c('br'), _vm._v("The honeymoon was barely over when Megan had a miscarriage and the scales fell from her eyes: she was trapped in a convenient marriage, and James expected her to conceive again soon. She should have demanded a divorce, but Megan was facing the uncomfortable truth: she'd fallen in love with her ruthless husband…."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Miranda Lee\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("After leaving her convent school, Miranda Lee briefly studied the cello before moving to Sydney, where she embraced the emerging world of computers. Her career as a programmer ended after she married, had three daughters and bought a small acreage in a semi-rural community. She yearned to find a creative career from which she could earn money. When her sister suggested writing romances, it seemed like a good idea. She could do it at home, and it might even be fun! She never looked back.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0